import http from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'

import { useToken } from '@/helpers/auth'
import { useCache } from '@/helpers/cache'
import { useConfig } from '@/helpers/config'

import { ErrorBus, NOT_FOUND_ERROR_EVENT } from '@/plugins/myAdelya/MyAdelyaEvent'

const API_URL = ( useConfig().API_URL || '' ) + '/wp-content/plugins/myAdelya/webservice/public'

let Api = http.create({
    baseURL: API_URL,
    adapter: cacheAdapterEnhancer(http.defaults.adapter, { defaultCache: useCache() }),
    headers: { Authorization: `Bearer ${useToken()}` },
    withCredentials: true
})

Api.interceptors.response.use(
    (response) => response,
    (error) => {
        
        const statusCode = error.response ? error.response.status : null;
        if (statusCode === 404) {
            ErrorBus.$emit(NOT_FOUND_ERROR_EVENT, "Oooops, la page que vous recherchez n'existe pas !")
            return Promise.reject(404);
        }

        return Promise.reject(error);
    }
);

let getFromLocation = location => {

    return new Promise( (resolve, reject) => {
        
            http.get(location, {
                headers: { Authorization: `Bearer ${useToken()}` }
            })
            .then( response => { resolve(response.data) } )
            .catch( error => reject(error) )

        })
}

export default Api
export { API_URL, getFromLocation }